import { Check } from "lucide-react";
import { RichText } from "../product/RichText";

// Beheerbare tekst: lege regel = nieuwe alinea, regels met "- " = opsomming, [label](/pad) = interne link.
export const TextBody = ({ text = "", className = "", testid }) => (
  <div className={`space-y-3 ${className}`} data-testid={testid}>
    {text.split(/\n\s*\n/).filter((p) => p.trim()).map((part, i) => {
      const lines = part.split("\n").map((l) => l.trim()).filter(Boolean);
      if (lines.every((l) => l.startsWith("- "))) {
        return (
          <ul key={i} className="grid gap-2">
            {lines.map((l) => <li key={l} className="flex items-start gap-2 text-[15px] leading-relaxed text-slate-700"><Check className="mt-1 h-4 w-4 shrink-0 text-maas" aria-hidden="true" /><span><RichText text={l.slice(2)} /></span></li>)}
          </ul>
        );
      }
      return <p key={i} className="max-w-[68ch] leading-relaxed text-slate-700"><RichText text={lines.join(" ")} /></p>;
    })}
  </div>
);
